import { CapitalDeposit } from '__generated__/GQL';
import { ApplicationType } from 'features/Onboarding/types';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getEuropeanBankAccountModuleStatus = ({
  applicationType,
  capitalDeposit,
}: {
  applicationType: ApplicationType;
  capitalDeposit: Pick<CapitalDeposit, 'hasEuropeanBankAccount'>;
}) => {
  if (
    ![ApplicationType.CapitalDeposit, ApplicationType.SasuCreation].includes(
      applicationType,
    )
  ) {
    return VerificationStatus.Irrelevant;
  }

  if (capitalDeposit.hasEuropeanBankAccount === null) {
    return VerificationStatus.ToDo;
  }

  return capitalDeposit.hasEuropeanBankAccount
    ? VerificationStatus.Completed
    : VerificationStatus.Invalid;
};

export { getEuropeanBankAccountModuleStatus };
